import { RedoModalHostElement } from "../modal-host-element";

/**
 * Shadow-host custom element for the "Pay with HSA/FSA" PDP badge: badge in
 * this element's shadow root, "Learn more" dialog on a body-appended host.
 */
export class RedoHsaPdpContainerElement extends RedoModalHostElement {
  constructor() {
    super("redo-hsa-pdp-modal-root");
  }

  static readonly TAG = "redo-hsa-pdp-container-element";
}
